<!-- Small and medium viewport -->
<div class="d-block d-lg-none p-0">
  <ng-container *ngFor="let sendgroup of sendGroups; let isFirstSendGroup = first;">
    <mobile-request-status-sendgroup-item [sendgroup]="sendgroup" [isFirstSendGroup]="isFirstSendGroup"></mobile-request-status-sendgroup-item>
  </ng-container>
</div>